































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/rules-engine';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { getHealthInsurance } from '@/services/prescription';
import {
  getAvailableEnteralCalculationTypes,
  getAvailableEnteralProducts,
  getAvailableTherapies,
} from '../../services/client-unit';
import ListMessages from '../UI/list-messages.vue';

@Component({
  components: { PermissionAuth, ListMessages },
})
export default class ClientUnitEnteralProducts extends BaseComponent {
  @Prop()
  public unit: any;
  @Prop({
    default: false,
  })
  public isEdit: boolean;

  private enteralsOptions: any[] = [];
  private obs: string = null;
  private loading: boolean = false;
  private error: boolean = false;

  private calculationTypes: any[] = [];

  @Watch('unit.id')
  private onUnitChange() {
    if (!this.unit || !this.unit.id) {
      return;
    }
    this.error = false;
    this.loading = true;
    this.addSubsc(
      getAvailableEnteralProducts(this.unit.id).subscribe(
        (result) => {
          this.enteralsOptions = result;
          let ids = this.unit.produtosEnterais.map((t) => t.id);
          this.unit.produtosEnterais = this.enteralsOptions.filter((f) => ids.indexOf(f.id) != -1);
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
    this.addSubsc(
      getAvailableEnteralCalculationTypes(this.unit.id).subscribe((result) => {
        this.calculationTypes = result;
      }),
    );
  }
}
